module.exports = __webpack_public_path__ + "img/ppr-group-systems-actions-dropdown.7999300c.svg";